// extracted by mini-css-extract-plugin
export default {"wrapper":"Comments_wrapper__TIuMB","header":"Comments_header__dbZ41","title":"Comments_title__vrdnD","controlls":"Comments_controlls__cLNOt","count":"Comments_count__+tBVU"};